const fetchHtml5ToGifDownload = url => fetch(url).then(res => res.blob());

export default fetchHtml5ToGifDownload;
